import { Component, OnInit, ViewChild } from '@angular/core';

import { AppMemoryService } from './../../core/app-memory.service';
import { GetService } from '../../core/get.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { TooltipComponent } from '../../core/tooltip/tooltip.component';
import { Router } from "@angular/router";

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.less']
})
export class ProfileComponent implements OnInit {
    public user$: Subscription;
    public user: User;
    public inviteCode: string;
    public isVet: boolean;
    public currentLang: Array<Object> = [];

    public assistants = {
        pending: [] as Users,
        approved: [] as Users,
        isLoaded: false as boolean
    };

    public vets = {
        pending: [] as Users,
        approved: [] as Users,
        isLoaded: false as boolean
    };

    public assistantStatus = {
        assistant_id: null as number,
        status: '' as string,
        comment: '' as string
    };

    public vetStatus = {
        vet_id: null as number,
        status: '' as string,
        comment: '' as string
    };

    public assistantInvite = {
        email: '' as string,
        email_snapshot: '' as string
    };

    public languages = [{
        id: '' as string,
        text: '' as string
    }];

    public serverError = null;
    public isRequestInProgress = false;
    public isRequestSuccess = false;

    public paginationInfo: Object = {};

    public pagination = {
        pending: {
            inProgress: false,
            nextPage: ''
        },
        approved: {
            inProgress: false,
            nextPage: ''
        }
    };

    public pagination2 = {
        pending: {
            inProgress: false,
            nextPage: ''
        },
        approved: {
            inProgress: false,
            nextPage: ''
        }
    };

    public code: string;
    public firstName: string;
    public lastName: string;

    public translation = {};

    public notify = {
        notify_ios: true,
        notify_email: true
    };

  public notifyFrequency = {
    notifyTreatment: undefined,
    notifyVaccination: undefined,
    notifyNotes: undefined,
    notifyDay: undefined
  };

    public _languages = environment.languages || [];
    public isShowTooltip: boolean;
    @ViewChild('inviteUserTutorial') tooltip: TooltipComponent;

    constructor(public appMemory: AppMemoryService,
                public getService: GetService,
                private notificationsService: NotificationsService,
                public translate: TranslateService,
                private router: Router) {
        const user$ = this.appMemory.userSubject.subscribe(e => {
            if (this.appMemory.user && e) {
                this.setUser(this.appMemory.user);
              this.notifyFrequency.notifyTreatment = this.appMemory.user.notifyTreatment;
              this.notifyFrequency.notifyVaccination = this.appMemory.user.notifyVaccination;
              this.notifyFrequency.notifyNotes = this.appMemory.user.notifyNotes;
                this.notifyFrequency.notifyDay = this.appMemory.user.notifyDay;

                this.firstName = this.appMemory.user.name;
                this.lastName = this.appMemory.user.last_name;

                if (this.user.roles[0].id === 1) {
                    this.getAssistants('pending');
                    this.getAssistants('approved');
                    this.getVets('pending');
                    this.getVets('approved');
                }
                this.setDefaultLanguage();
                this.getLanguages();
            }
        });
        this.getTranslation();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        if (this.user$) {
            this.user$.unsubscribe();
        }
    }

    getTooltip() {
        return this.isShowTooltip = this.appMemory.getTooltip();
    }

    showTooltip(key, localClass) {
        return this.tooltip.showTooltip(key, localClass);
    }

    notifyChange(field) {
        this.notify[field] = !this.notify[field];
        this.getService.updateNotify(this.notify);
    }

  saveNotifyConfigToServer() {
        this.appMemory.user.notifyTreatment = this.notifyFrequency.notifyTreatment;
        this.appMemory.user.notifyVaccination = this.notifyFrequency.notifyVaccination;
        this.appMemory.user.notifyNotes = this.notifyFrequency.notifyNotes;
        this.appMemory.user.notifyDay = this.notifyFrequency.notifyDay;

        this.getService.updateNotifyFrequencyByType(this.notifyFrequency);
    }

    setUser(user: any) {
        this.user = user;
        this.notify.notify_ios = user.notify_ios;
        this.notify.notify_email = user.notify_email;

        if (user.referralcode) {
            this.inviteCode = user.referralcode.code;
        } else {
            this.inviteCode = null;
        }
    }

    setLang(event) {
        this.translate.use(event.id);
        this.getService.setDefaultUser({ language: event.id }).then(res => {
                    window.location.reload();
        });
        
        localStorage.setItem('equineLang', event.id);

        this.translate.get(`CORE.${this.translate.currentLang}`).subscribe((res: string) => {
            this.currentLang = [{
                id: this.translate.currentLang,
                text: res
            }];
        });
        
        this.getLanguages();
    }

    getLanguages() {
        this.languages = [] as Array<{ id: string, text: string }>;
        return this.translate.getLangs().forEach((lang: string) => {
            this.translate.get(`CORE.${lang}`).subscribe((res: string) => {
                return this.languages.push({
                    id: lang,
                    text: res
                });
            });
        });
    }

    setDefaultLanguage() {
        localStorage.setItem('equineLang', this.user.language);
        this.translate.get(`CORE.${this.user.language || this.translate.currentLang || environment.defaultLanguage}`)
            .subscribe((res: string) => {
                return this.currentLang = [{
                    id: this.user.language || this.translate.currentLang || environment.defaultLanguage,
                    text: res
                }];
            });
    }

    getAssistants(status: string) {
        this.isRequestInProgress = true;
        this.getService.getAssistants(status).then(
            (res: any) => {
                this.isRequestInProgress = false;
                this.assistants[status] = res.data;

                this.pagination[status].nextPage = res.next_page_url;

                if (this.assistants[status].length > 0 && !this.assistants.isLoaded) {
                    this.assistants.isLoaded = true;
                }
            },
            (err: any) => {
                console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    getVets(status: string) {
        this.isRequestInProgress = true;
        this.getService.getVets(status).then(
            (res: any) => {
                this.isRequestInProgress = false;
                this.vets[status] = res.data;

                this.pagination2[status].nextPage = res.next_page_url;

                if (this.vets[status].length > 0 && !this.vets.isLoaded) {
                    this.vets.isLoaded = true;
                }
            },
            (err: any) => {
                console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    inviteAssistant(form: any) {
        this.serverError = null;
        this.isRequestSuccess = false;

        if (form.form.invalid) {
            console.log('Form invalid!');
            return;
        }

        this.isRequestInProgress = true;
        this.getService.inviteAssistant(this.assistantInvite).then(
            (res: any) => {
                this.isRequestInProgress = false;
                this.isRequestSuccess = true;
                this.assistantInvite.email_snapshot = this.assistantInvite.email;
                this.clearUserInput(form);
            },
            (err: any) => {
                console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.isRequestSuccess = false;
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    requestTrainer(form: any) {
        this.serverError = null;
        this.isRequestSuccess = false;

        if (form.form.invalid) {
            console.log('Form invalid!');
            return;
        }

        this.isRequestInProgress = true;
        this.getService.requestTrainer(this.code).then(
            (res: any) => {
                this.isRequestInProgress = false;
                this.isRequestSuccess = true;
                this.clearUserInput(form);
            },
            (err: any) => {
                // console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.isRequestSuccess = false;
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    clearUserInput(form: any, close?: boolean, noResetForm?: boolean) {
        if (!noResetForm) {
            form.resetForm();
        }
        this.serverError = null;
        this.assistantInvite.email = '';
        this.assistantStatus.comment = '';
        this.code = '';
        this.firstName = this.appMemory.user.name;
        this.lastName = this.appMemory.user.last_name;

        if (close) {
            $('#assistant-invite-email-box').removeClass('input--filled');
            $('#assistant-invite-email-box').removeClass('input--filled');
            $('#request-trainer-code-box').removeClass('input--filled');
            $('#first-name-code-box').removeClass('input--filled');
            $('#last-name-code-box').removeClass('input--filled');
            this.isRequestSuccess = false;
        }
    }

    objectToArray(obj: Object) {
        return Object.keys(obj).map(key => obj[key]); // transform Array-like Object to Array
    }

    showAnimatedNotify(element: any, elementA: string) {
        if (!element.classList.contains('animating')) {
            element.classList.add('animating');
            $(elementA)
                .fadeIn('fast')
                .delay(1000)
                .fadeOut('fast', function () {
                    element.classList.remove('animating');
                });
        }
    }

    changeAssistantStatus(id: number, status: string, form?: any) {
        if (form && form.form.invalid) {
            console.log('Form invalid!');
            return;
        }

        this.assistantStatus.status = status;

        if (!this.assistantStatus.comment) {
            this.assistantStatus.comment = undefined;
        }

        this.isRequestInProgress = true;
        this.getService.changeAssistantStatus(id, this.assistantStatus).then(
            (res: any) => {
                this.isRequestInProgress = false;

                $('#comment-box').removeClass('input--filled');

                this.hideModal();

                this.getAssistants('pending');
                this.getAssistants('approved');

                this.getVets('pending');
                this.getVets('approved');

                if (form) {
                    this.clearUserInput(form);
                }
            },
            (err: any) => {
                console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    hideModal() {
        $('.modal.open').removeClass('open');
        $('body').removeClass('modal-open');
    }

    addNewData(items: any, status: string) {
        switch (items) {
            case this.assistants.approved:
                if (
                    this.pagination[status].nextPage === null ||
                    this.pagination[status].inProgress ||
                    this.pagination[status].nextPage === ''
                ) {
                    return;
                }

                this.pagination[status].inProgress = true;
                this.getService.rawRequest(this.pagination[status].nextPage).then(
                    (res: any) => {
                        res.data.forEach((item: any) => {
                            items.push(item);
                        });
                        this.pagination[status].nextPage = res.next_page_url;
                        this.pagination[status].inProgress = false;
                    },
                    (err: any) => {
                        this.pagination[status].inProgress = false;
                    }
                );
                break;

            case this.vets.approved:
                if (
                    this.pagination2[status].nextPage === null ||
                    this.pagination2[status].inProgress ||
                    this.pagination2[status].nextPage === ''
                ) {
                    return;
                }

                this.pagination2[status].inProgress = true;
                this.getService.rawRequest(this.pagination2[status].nextPage).then(
                    (res: any) => {
                        res.data.forEach((item: any) => {
                            items.push(item);
                        });
                        this.pagination2[status].nextPage = res.next_page_url;
                        this.pagination2[status].inProgress = false;
                    },
                    (err: any) => {
                        this.pagination2[status].inProgress = false;
                    }
                );
                break;
        }
    }

    onScrollAssistants(e) {
        if (
            e.srcElement.scrollHeight - e.srcElement.scrollTop ===
            e.srcElement.clientHeight
        ) {
            this.addNewData(this.assistants.approved, 'approved');
        }
    }

    onScrollVets(e) {
        if (
            e.srcElement.scrollHeight - e.srcElement.scrollTop ===
            e.srcElement.clientHeight
        ) {
            this.addNewData(this.vets.approved, 'approved');
        }
    }

    changeName(form: any) {
        this.serverError = null;
        this.isRequestSuccess = false;

        if (form.form.invalid) {
            console.log('Form invalid!');
            return;
        }

        const body = {
            name: this.firstName,
            last_name: this.lastName
        };

        this.isRequestInProgress = true;
        this.getService.changeName(body).then(
            (res: any) => {
                this.isRequestInProgress = false;
                this.appMemory.user.name = this.firstName;
                this.appMemory.user.last_name = this.lastName;
                this.hideModal();
                this.notificationsService.success(
                    `${this.translation['changeName']}`,
                    `${this.translation['usernameChanged']}`,
                );
            },
            (err: any) => {
                console.log('THIS.SERVERERROR', this.serverError);
                this.isRequestInProgress = false;
                this.isRequestSuccess = false;
                this.notificationsService.error(
                    `${this.translation['changeName']}`,
                    `${this.translation['errorOccurred']}`
                );
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    goToInvoice() {
        this.router.navigateByUrl('/invoices');
    }

    goToInfo() {
        this.router.navigateByUrl('/info');
    }

    getTranslation() {
        this.translate.get('PROFILE.changeName').subscribe((word: string) => {
            this.translation['changeName'] = word;
        });
        this.translate.get('PROFILE.usernameChanged').subscribe((word: string) => {
            this.translation['usernameChanged'] = word;
        });
    }

    debug(e) {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/profile/profile.component.ts